import { PropsWithChildren } from 'react';

import {
  getVariantCategory,
  getVariantCategoryColor,
} from '@/helpers/products';
import { VariantValue } from '@/types/IProduct';
import { ProfileProduct } from '@/types/IProfile';

type BadgeProps = {
  type: VariantValue;
} & PropsWithChildren;

export function Badge({ children, type }: BadgeProps) {
  return (
    <span
      className={`text-xs rounded-full font-medium px-2 py-0.5 ${getVariantCategoryColor(
        type,
      )}`}
    >
      {children}
    </span>
  );
}

type ProductBadgesProps = {
  products: ProfileProduct[];
};

export function ProductBadges({ products }: ProductBadgesProps) {
  if (products.length === 0) {
    return null;
  }

  const supportedProducts = products.filter(product =>
    getVariantCategory(product.type),
  );

  if (supportedProducts.length === 0) {
    return null;
  }

  const [first, ...rest] = supportedProducts;

  return (
    <div className="group relative inline-flex items-center space-x-1">
      <Badge type={first.type}>{getVariantCategory(first.type)}</Badge>

      {rest.length > 0 && (
        <>
          <Badge type={rest[0].type}>+{rest.length}</Badge>

          {/* tooltip */}
          <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 mt-3 bg-white shadow-xl rounded-xl p-3 inline-flex flex-col items-start gap-2 whitespace-nowrap opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition duration-150 ease-out pointer-events-none">
            <span className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-3 bg-white rotate-45 shadow-[0_1px_2px_rgba(0,0,0,0.06)]" />
            {rest.map((product, index) => (
              <Badge key={index} type={product.type}>
                {getVariantCategory(product.type)}
              </Badge>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
